<template>
    <div>
        <div id="mainhold">
            <div id="leftcolumn" class="cols">SEND UPS ENVELOPE<br>
            <div id="shipQuote" class="cols" @click="showForm">SHIP QUOTE</div>
            <div id="shipFrom" v-if="isQuoting">
                <div id="senderInfo" class="wrapper">
                <input type="text" class="instyle" placeholder="Sender Name" v-model="shipper">
                <input type="text" class="instyle" placeholder="Street" v-model="sstreet">
                <input type="text" class="instyle" placeholder="Unit" v-model="sunit">
                <input type="text" class="instyle" placeholder="City" v-model="scity">
                <input type="text" class="instyle" placeholder="State" v-model="sstate">
                <input type="text" class="instyle" placeholder="Zipcode" v-model="szipcode">
                </div>
                <div id="packinfo" class="wrapper"><br><br>
                Package Info
                <br>
                <input type="text" class="instyle" placeholder="Box Width" v-model="packageW">
                <input type="text" class="instyle" placeholder="Box Height" v-model="packageH">
                <input type="text" class="instyle" placeholder="Box Length" v-model="packageL">
                <input type="text" class="instyle" placeholder="$ Price" v-model="itemPrice">
                </div>
            </div>
                <input type="text" class="instyle" placeholder="Name" v-model="recipient">
                <input type="text" class="instyle" placeholder="Street" v-model="street">
                <input type="text" class="instyle" placeholder="Unit" v-model="unit">
                <input type="text" class="instyle" placeholder="City" v-model="city">
                <input type="text" class="instyle" placeholder="State" v-model="state">
                <input type="text" class="instyle" placeholder="Zipcode" v-model="zipcode">
                <input type="text" class="instyle" placeholder="Weight" v-model="weight">
                <div class="btn bgPink" v-if="isQuoting" @click="getQuote">GET QUOTE</div>
                <div class="btn bgTeal" v-if="!isQuoting" @click="makeLabel">MAKE LABEL</div>
            </div>
            <div id="rightcolumn" class="cols"></div>
            <div id="quotes" v-if="isQuoting">
                <div id="option1" class="wrapper" @click="shipChoose('ups_2nd_day_air')">{{ups2day}} || {{twodayCost}}</div>
                <div id="option1" class="wrapper" @click="shipChoose('ups_3_day_select')">{{ups3day}} || {{threedayCost}}</div>
                <div id="option1" class="wrapper" @click="shipChoose('ups_ground')">{{upsGround}} || {{groundCost}}</div>
            </div>

                <div class="amTealregular" @click="showLabel(labellink)">Label Link<br>{{labellink}}</div>
                <div class="spacer"></div>
                <div class="amGrayregular">Cost: ${{shipcost}} | Tracking: {{tracking_number}} | LabelID: {{label_id}}</div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/functions'
import 'firebase/firestore'
export default {
    name: "upslabels",
    data(){
        return {
            street: "",
            unit: "",
            city: "",
            state: "",
            recipient: "",
            zipcode: "",
            sstreet: "",
            sunit: "",
            scity: "",
            sstate: "",
            shipper: "",
            szipcode: "",
            weight: "",
            labellink: "",
            shipcost: "",
            tracking_number: "",
            label_id: "",
            itemPrice: "",
            nextday: "ups_next_day_air_saver",
            ground: "ups_ground",
            overnight: "ups_overnight",
            service_code: "",
            upsLetter: "ups_letter",
            upsBox: "",
            package_code: "",
            isQuoting: false,
            packageW: "",
            packageH: "",
            packageL: "",
            upsGround: "",
            ups2day: "",
            ups3day: "",
            upsNextdaysaver: "",    
            otherAmt3: "",
            otherAmt0: "",
            otherAmt5: "",
            otherAmt2: "",
            groundCost: "",
            nextdayCost:"",
            twodayCost: "",
            threedayCost: "",
            isReal: true,
            chosenMethod: ""

        }
    },
    methods: {
        shipChoose(method){
            this.chosenMethod = method
            this.buyLabel()
        },
        getQuote(){
            if (
                this.street !== "" || 
                this.recipient !== "" || 
                this.city !== "" ||
                this.state !== "" ||
                this.zipcode !== "" ||
                this.sstreet !== "" ||
                this.scity !== "" ||
                this.szipcode !== "" ||
                this.sstate !== "" ||
                this.packageW !== "" ||
                this.packageH !== "" ||
                this.packageL !== ""){

                    console.log(this.zipcode, this.szipcode)
                
                const shipQuote = firebase.functions().httpsCallable('shipQuote');
                return shipQuote({
                    city: this.city,
                    zipcode: this.zipcode,
                    state: this.state,
                    country: "US",
                    price: this.itemPrice,
                    recipient: this.recipient,
                    width: this.packageW,
                    height: this.packageH,
                    length: this.packageL,
                    unitSize: "inch",
                    unitWeight: this.weight,
                    scity: this.scity,
                    szipcode: this.szipcode,
                    sstate: this.sstate,
                    scountry: "US",
                    sender: this.shipper
                })
                .then ((result) => {
                    if(result){
                        console.log('got here')
                        // const arr = JSON.parse(result);
                        const arr = result.data;
                        const doc = JSON.parse(arr)
                        // console.log('HEEEEEE=====> ', doc, '22222====', Array.isArray(doc), 'leng==>>', doc.length);
                        this.upsGround = doc[3].service_type;
                        this.otherAmt3 = parseFloat(doc[3].other_amount.amount.toFixed(2));
                        this.otherAmt0 = parseFloat(doc[3].other_amount.amount.toFixed(2));
                        this.otherAmt5 = parseFloat(doc[3].other_amount.amount.toFixed(2));
                        this.otherAmt2 = parseFloat(doc[3].other_amount.amount.toFixed(2));
                        const groundShip = parseFloat(doc[3].shipping_amount.amount.toFixed(2));
                        this.groundCost = groundShip + this.otherAmt3
                        this.ups2day = doc[0].service_type;
                        const twoDay = parseFloat(doc[0].shipping_amount.amount.toFixed(2));
                        this.upsNextdaysaver = doc[5].service_type;
                        const nextDay = parseFloat(doc[5].shipping_amount.amount.toFixed(2));
                        this.nextdayCost = nextDay + this.otherAmt5
                        this.twodayCost = twoDay + this.otherAmt0
                        const threeDay = parseFloat(doc[2].shipping_amount.amount.toFixed(2));
                        this.threedayCost = threeDay + this.otherAmt2
                        this.ups3day = doc[2].service_type;

                        console.log(this.upsGround ,' - ', this.groundCost, this.ups2day, ' - ', this.twodayCost, this.nextday, ' - ', this.nextdayCost, this.ups3day, ' - ', this.threedayCost)
                        return;
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
            } else {
                alert ("Incomplete Form")
            }
        },
        buyLabel(){
            if (this.street !== "" || this.recipient !== "" || this.city !== "" || this.state !== "" || this.zipcode !== "" || this.weight !== ""){
                const data = ({
                    street: this.street,
                    unit: this.unit,
                    city:this.city,
                    state: this.state,
                    zipcode: this.zipcode,
                    weight: this.weight,
                    recipient: this.recipient,
                    service_code: this.chosenMethod,
                    package_code: "ups_letter",
                    country: 'US',
                    scountry: 'US',
                    sstreet: this.sstreet,
                    sunit: this.sunit,
                    scity:this.scity,
                    sstate: this.sstate,
                    szipcode: this.szipcode,
                    sender: this.shipper,
                    isReal: this.isReal,
                    unitSize: "inch"

                })
            
            console.log('oooooooo',data)
            const reqLabel = firebase.functions().httpsCallable('boxShipper')
            reqLabel(data).then(result => {
                if(result){
                    const {label_id, tracking_number, shipment_cost, label_download} = JSON.parse(result);
                    this.tracking_number = tracking_number
                    this.labellink = label_download && label_download.pdf
                    this.shipcost = shipment_cost && shipment_cost.amount
                    this.label_id = label_id
                    console.log("result is....", result, this.tracking_number, this.labellink, this.shipcost)
                }
            }).catch(err => {
                console.log("Error Occurred", err)
            })
            } else {
                alert('Empty Fields')
                return
            }
        },
        makeLabel(){
            if (this.street !== "" || this.recipient !== "" || this.city !== "" || this.state !== "" || this.zipcode !== "" || this.weight !== ""){
                const data = ({
                    street: this.street,
                    unit: this.unit,
                    city:this.city,
                    state: this.state,
                    zipcode: this.zipcode,
                    weight: this.weight,
                    recipient: this.recipient,
                    service_code: this.nextday,
                    package_code: this.upsLetter
                })
            const reqLabel = firebase.functions().httpsCallable('amShip')
            reqLabel(data).then(result => {
                if(result){
                    const {label_id, tracking_number, shipment_cost, label_download} = JSON.parse(result);
                    this.tracking_number = tracking_number
                    this.labellink = label_download && label_download.pdf
                    this.shipcost = shipment_cost && shipment_cost.amount
                    this.label_id = label_id
                    console.log("result is....", result, this.tracking_number, this.labellink, this.shipcost)
                }
            }).catch(err => {
                console.log("Error Occurred", err)
            })
            } else {
                alert('Empty Fields')
                return
            }
        },
        showLabel(link){
            const printlabel = link
            window.open(printlabel, "_blank")
        },
        showForm(){
            if (this.isQuoting == false){
                this.isQuoting = true
            } else {
                this.isQuoting = false
            }
        }
    }
}
</script>


<style scoped>

.mainwrap {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
    text-align: left;
}

.spacer {
    width: 100%;
    height: 20px;
    float: left;
    clear: right;
}
    #mainhold {
    width: 100%;
    height: 55vh;
    background-color: white;
    position: relative;
    overflow: scroll;
    position: relative;
}

.cpointer {
    cursor: pointer;
}

.btn {
    width: auto;
    height: auto;
    padding: 2%;
    border-radius: 2vmin;
    text-align: center;
    color: white;
    float:right;
    clear: right;
}

#rightcol {
    width: auto;
    height: auto;
    position: fixed;
    top: 0;
    margin-top: 300px;
    right: 0;
    margin-left: 50vw;
}

.imgHolder {
    width: 50px;
    height: 50px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    clear: right;
}

.imgHolder2 {
    width: 250px;
    height: 250px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    clear: right;
}

.wrapper {
    width: 60%;
    float: left;
    clear: right;
    height: auto;
    text-align: right;
    margin-left: 20px;
}

.instyle {
    width: 100%;
    height: 50px;
    border-style: solid;
    background-color: azure;
    padding: 1%;
    float: left;
    clear: right;
    margin-bottom: 5px;
}

.wrapperr {
    width: 60%;
    float: left;
    clear: right;
    height: auto;
    text-align: left;
    margin-left: 20px;
}

.listingholder {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
    padding: 2%;
    margin-bottom: 5px;
}

.cols {
    width: 50%;
    height: auto;
    float: left;
    clear: right;
    padding: 5%;
    border-right-color: #00a89d;
    border-right-width: 2px;
    overflow: scroll;
}
</style>